<template>
  <div id="blog">
    <providers
      :form-params="formParams"
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
    />
    <beneficiary
      :form-params="formParams"
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
    />
    <sub-beneficiary
      :form-params="formParams"
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
    />
    <website-page
      :form-params="formParams"
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
    />
    <div class="vx-col w-1/2">
      <vs-button @click="popUps.popupAddProvider=true" color="primary" type="border">Insert deal</vs-button>
      <vs-button @click="popUps.popupAddBeneficiary=true" color="warning" type="border">Add Beneficiary</vs-button>
      <vs-button @click="popUps.popupAddSubBeneficiary=true" color="success" type="border">Add Sub Beneficiary</vs-button>
      <vs-button @click="publishPage()" color="danger" type="border">Publish Index</vs-button>
    </div>
    <table-view 
      :component-key="componentKey"
      :end-point="endPoint"
      :column-defs="columnDefs"
      :form-params="formParams"
      :pop-ups="popUps"
      :filters="filters"
      :buttons="buttons"
      :params="params"
      :call-url="callUrl"
      >
    </table-view>
  </div>
</template>

<script>
import axios from "@/axios.js"
import TableView from '../../components/tableView';
import WebsitePage from '../../components/forms/WebsitePage.vue';
import Providers from '../../components/forms/Providers.vue';
import Beneficiary from '../../components/forms/Beneficiary.vue';
import SubBeneficiary from '../../components/forms/SubBeneficiary.vue';
export default {
  components: {
    TableView,
    WebsitePage,
    Providers,
    Beneficiary,
    SubBeneficiary
  },
  data() {
     let data = {
      componentKey: 0,
      popUps:{popupAddActive: false,popupAddProvider:false,popupAddBeneficiary:false,popupAddSubBeneficiary:false},
      params:{title:'',formType:'add',country:null,deal:null},
      formParams:{pageName:'',pageDescription:'',pageTitle:'',formType:'add'},
      lineDetails:{},
      callUrl: 'https://crm.evblock.com/api/blog',
      filters:{disable:true},
      columnDefs: [
        {
          headerName: 'Name',
          field: 'pageName',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Url',
          field: 'pageUrl',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Title',
          field: 'pageTitle',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Description',
          field: 'pageDescription',
          filter: true,
          width: 250,
        },
        {
          headerName: 'IsPublished',
          field: 'isPublished',
          filter: true,
          width: 250,
        },
        {
          headerName: 'QuickEdit',
          field:'editQuickPage',
          action: 'editQuickPage',
          filter: false,
          cellStyle: {color: 'orange'},
          cellRenderer: function() {
            return 'Edit';
          }
        },
        {
          headerName: 'Edit',
          field:'editPage',
          action: 'editPage',
          filter: false,
          cellStyle: {color: 'blue'},
          cellRenderer: function() {
            return 'Edit';
          }
        }
      ],
      endPoint:'blog',
      buttons:{
          addForm: true,
      },
    }
    return data;
  },
  computed: {
  },
  methods: {
    translate: function(key){
      return this.$t(key);
    },
    publishPage: function(){
      let that = this;
      this.$vs.loading();
      this.params.action = 'generate-index';
      axios.put("https://crm.evblock.com/api/blog",this.params)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.openAlert('success','Success');
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        delete this.params.action;
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    closePopups: function(){
      this.componentKey++;
      this.popUps.popupAddActive = false;
      this.popUps.popupAddProvider = false;
      this.popUps.popupAddBeneficiary= false;
      this.popUps.popupAddSubBeneficiary= false;
      this.formParams = {formType:'add'};
      this.$forceUpdate();
    }
  },
  mounted() {

  }
}

</script>